import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import type { MdfDraftPatchInput } from "@colab/shared";

// PATCH /api/portal/mdf/drafts/:id — auto-save call. The orchestrator hook
// (use-mdf-runtime) debounces the firing of this mutation at 500ms; the
// hook itself just wraps the apiFetch.
//
// **No cache invalidation.** The draft body lives in react-hook-form local
// state during the editing session — invalidating `mdf.draft(id)` would
// refetch the server's view and clobber any in-flight edits. The
// "Saving / Saved / Error" indicator the UI shows is driven by this
// mutation's isPending / isSuccess / isError flags, not by query state.
//
// Bucket 9 convention: local-state optimism only. See MIGRATION.md.
export function useSaveMdfDraft(draftId: string) {
  return useMutation<void, ApiClientError, MdfDraftPatchInput>({
    mutationFn: async (body) => {
      await apiFetch<{ ok: true }>(`/portal/mdf/drafts/${draftId}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      });
    },
  });
}
